import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { NotifyPartyAdapter } from './dto/notify-party.adapter';
import { NotifyParty } from './notify-party.entity';
import { NotifyPartyDTO } from './dto/notify-party.dto';
import { AllNotifyPartyResponse, CommonResponse, NotifyPartyResponse, NotifyPartyDropDownDto } from '@gtpl/shared-models/masters'
import { NotifyPartyRequest } from './dto/notify-party.request';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { UserRequestDto } from '../countries/dto/user-request-dto';
@Injectable()
export class NotifyPartyService {
    constructor(
      private logService:LogsService,
        @InjectRepository(NotifyParty) private notifyPartyRepository: Repository<NotifyParty>,
        private notifyPartyAdapter: NotifyPartyAdapter,
    ) { }
    async createNotifyParty(notifyPartyDTO: NotifyPartyDTO, isUpdate: boolean): Promise<NotifyPartyResponse> {
        try {
            let presentValue;
            if (!isUpdate) {
                const notifyPartyEntity = await this.getNotifyParty(notifyPartyDTO.notifyPartyName);
                if (notifyPartyEntity) {
                    throw new NotifyPartyResponse(false, 11104, 'Notify party already exists');
                }
            }
            else {
                const previousVal = await this.notifyPartyRepository.findOne({where:{notifyPartyId:notifyPartyDTO.notifyPartyId}})
                presentValue = previousVal.notifyPartyName
                const notifyPartyEntity = await this.getNotifyParty(notifyPartyDTO.notifyPartyName);
                if (notifyPartyEntity) {
                    if (notifyPartyEntity.notifyPartyId != notifyPartyDTO.notifyPartyId) {
                        throw new NotifyPartyResponse(false, 11104, 'Notify Party  already exists');
                    }
                }
            }
            const convertednotifyPartyEntity: NotifyParty = this.notifyPartyAdapter.convertDtoToEntity(notifyPartyDTO, isUpdate);
            const savednotifyPartyEntity: NotifyParty = await this.notifyPartyRepository.save(convertednotifyPartyEntity);
            const savednotifyPartyDTO: NotifyPartyDTO = this.notifyPartyAdapter.convertEntityToDto(savednotifyPartyEntity);
            if (savednotifyPartyDTO) {
            const presentVal = savednotifyPartyDTO.notifyPartyName;
                const response = new NotifyPartyResponse(true, isUpdate ? 11100 : 11101, isUpdate ? 'Notify party date Updated Successfully' : 'Notify party Created Successfully', savednotifyPartyDTO);
                const name=isUpdate?'updated':'created'
                const displayValue = isUpdate? 'Notify party Updated Successfully': 'Notify party Created Successfully'
            const userName = isUpdate? savednotifyPartyDTO.updatedUser :savednotifyPartyDTO.createdUser;
                const newLogDto = new LogsDto(1,name, 'NotifyParty', savednotifyPartyDTO.notifyPartyId, true, displayValue,userName,presentValue,presentVal)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return response;
            } else {
                throw new NotifyPartyResponse(false, 11106, 'Notify party saved but issue while transforming into DTO');
            }
        }
        catch (error) {
            return error;
        }
    }
    /**
     * gets all Notify Party details  
     * @returns all the Notify Party details .
     */

    async getAllNotifyParty(req?:UserRequestDto): Promise<AllNotifyPartyResponse> {
        try {
            const notifyPartyDTO: NotifyPartyDTO[] = [];

            const notifyPartyEntities: NotifyParty[] = await this.notifyPartyRepository.find({
                order: { notifyPartyName: "ASC" },
            });

            if (notifyPartyEntities.length > 0) {
                notifyPartyEntities.forEach(notifyPartyEntity => {
                    const convertednotifyPartyDTO: NotifyPartyDTO = this.notifyPartyAdapter.convertEntityToDto(notifyPartyEntity);
                    notifyPartyDTO.push(convertednotifyPartyDTO);
                });
                const response = new AllNotifyPartyResponse(true, 11208, "Notify Party retrieved successfully", notifyPartyDTO);
                if(req?.createdUser){
                    const newLogDto = new LogsDto(1,'view', 'NotifyParty', 0, true, 'Notify Party retrieved successfully',req.createdUser,'','')
                    let res = await this.logService.createLog(newLogDto);
                    console.log(res);
                }
                return response;
            } else {
                //   console.log('yest')
                throw new NotifyPartyResponse(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }
    async getNotifyParty(notifyPartyName: string): Promise<NotifyParty> {

        const response = await this.notifyPartyRepository.findOne({
            where: { notifyPartyName: notifyPartyName },
        });
        console.log(response, '?????????');
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    /**
     * It deactivates value    Notify Party   
     * @param itemReq      Notify Party as string
     * @returns true or false
     */
    async activateOrDeactivateNotifyParty(notifyPartyReq: NotifyPartyRequest): Promise<NotifyPartyResponse> {
        try {
            const notifyPartyExists = await this.getNotifyPartyById(notifyPartyReq.notifyPartyId);
            if (notifyPartyExists) {
                if (notifyPartyReq.versionFlag !== notifyPartyExists.versionFlag) {
                    throw new NotifyPartyResponse(false, 10113, 'Someone updated the current NotifyParty information.Refresh and try again');
                } else {

                    const notifyPartyStatus = await this.notifyPartyRepository.update(
                        { notifyPartyId: notifyPartyReq.notifyPartyId },
                        { isActive: notifyPartyReq.isActive, updatedUser: notifyPartyReq.updatedUser });

                    if (notifyPartyExists.isActive) {
                        if (notifyPartyStatus.affected) {
                            const notifyPartyResponse: NotifyPartyResponse = new NotifyPartyResponse(true, 10115, 'Notify Party is de-activated successfully');
                            return notifyPartyResponse;
                        } else {
                            throw new NotifyPartyResponse(false, 10111, 'Notify Party is already deactivated');
                        }
                    } else {
                        if (notifyPartyStatus.affected) {
                            const notifyPartyResponse: NotifyPartyResponse = new NotifyPartyResponse(true, 10114, 'Notify Party is activated successfully');
                            return notifyPartyResponse;
                        } else {
                            throw new NotifyPartyResponse(false, 10112, 'Notify Party is already  activated');
                        }
                    }
                    // }
                }
            } else {
                throw new NotifyPartyResponse(false, 99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getNotifyPartyById(notifyPartyId: number): Promise<NotifyParty> {
        //  console.log(employeeId);
        const response = await this.notifyPartyRepository.findOne({
            where: { notifyPartyId: notifyPartyId },
        });

        if (response) {
            return response;
        } else {
            return null;
        }
    }
    
    async getAllNotifyPartyDropDown(): Promise<CommonResponse> {
        try {
            const notifyPartyDto: NotifyPartyDropDownDto[] = [];
            // retrieves all plants
            const notifyPartyEntities: NotifyParty[] = await this.notifyPartyRepository.find({
                order: { notifyPartyName: "DESC" }, where: { isActive: true }
            });
            if (notifyPartyEntities.length > 0) {
                notifyPartyEntities.forEach(notifyPartyEntity => {
                    const convertednotifyPartyDto = new NotifyPartyDropDownDto(notifyPartyEntity.notifyPartyId, notifyPartyEntity.notifyPartyName);
                    notifyPartyDto.push(convertednotifyPartyDto);
                });
                const response = new CommonResponse(true, 11208, "Notify Party retrieved successfully", notifyPartyDto);
                return response;
            } else {
                throw new NotifyPartyResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }


    async getNotifyPartyInfoById(req:{notifyPartyId: number}):Promise<NotifyPartyResponse> {
        try {
            const response = await this.notifyPartyRepository.findOne({
                where: { notifyPartyId: req.notifyPartyId },
            });
            console.log(response);
            if (response.notifyPartyId > 0) {
                return new NotifyPartyResponse(true, 11111, 'notify Party Info Retrieved Successfully', response);
            } else {
                return new NotifyPartyResponse(false, 99999, 'Not Found');
            }
        } catch (error) {
            return error;
        }
    }
    
}